<!-- 统计分析 -->
<template>
    <div class="statistical-analysis">
        <div class="search">
            <table>
                <tbody>
                    <tr>
                        <td style="width: 25%;">
                            <div class="search-item clearfix">
                                <div class="label left">
                                    行政区
                                </div>
                                <div class="item left">
                                    <el-select size="small" v-model="xzq" placeholder="请选择">
                                        <el-option
                                                v-for="item in xzqList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </td>
                        <td style="width: 50%;" colspan="2">
                            <div class="search-item clearfix">
                                <div class="label left">
                                    统计时间
                                </div>
                                <div class="item left time-item clearfix">
                                    <div class="left" style="width: 330px;">
                                        <el-radio v-model="time" label="all">全部</el-radio>
                                        <el-radio v-model="time" label="year">本年度</el-radio>
                                        <el-radio v-model="time" label="quarter">本季度</el-radio>
                                        <el-radio v-model="time" label="month">本月</el-radio>
                                        <el-radio v-model="time" label="custom">自定义</el-radio>
                                    </div>
                                    <div class="custom-time left">
                                        <el-date-picker
                                                size="small"
                                                :disabled="time !== 'custom'"
                                                v-model="customTime"
                                                type="daterange"
                                                range-separator="至"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期">
                                        </el-date-picker>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td style="width: 25%;">
                            <div class="search-item">
                                <el-button size="small" type="primary" @click="statisticsData">统计</el-button>
                                <el-button size="small" @click="resetForm">重置</el-button>
                                <el-button size="small" @click="moreButton">更多</el-button>
                            </div>
                        </td>
                    </tr>
                    <tr v-show="moreSearchShow">
                        <td>
                            <div class="search-item clearfix">
                                <div class="label left">
                                    过会状态
                                </div>
                                <div class="item left">
                                    <el-select size="small" v-model="ghzt" placeholder="请选择">
                                        <el-option
                                                v-for="item in ghztList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </td>
                        <td style="width: 25%;">
                            <div class="search-item clearfix">
                                <div class="label left">
                                    用地性质
                                </div>
                                <div class="item left">
                                    <el-select size="small" v-model="tdyt" placeholder="请选择">
                                        <el-option
                                                v-for="item in tdytList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </td>
                        <td style="width: 25%;">
                            <div class="search-item clearfix">
                                <div class="label left">
                                    成交状态
                                </div>
                                <div class="item left">
                                    <el-select size="small" v-model="cjzt" placeholder="请选择">
                                        <el-option
                                                v-for="item in cjztList"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-group" style="display: inline-flex;">
            <el-button icon="iconfont icon-daoru" size="small" type="primary" @click="exportDk">导出详细列表</el-button>
        </div>
        <div :class="moreSearchShow? 'analysis-content more-show': 'analysis-content'">
            <el-scrollbar style="height: 100%;">
                <div class="box-content">
                    <div>
                        <div class="header">
                            各行政区地块情况分析
                        </div>
                        <div class="content">
                            <table>
                                <thead>
                                    <th>行政区</th>
                                    <th>地块数量</th>
                                    <th>地块总面积(亩)</th>
                                    <th>成交金额(万元)</th>
                                    <th>操作</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in tableList" :key="'tableList'+ index">
                                        <td>
                                            <span v-html="item.xzq"></span>
                                        </td>
                                        <td>
                                            <span v-html="item.dksl"></span>
                                        </td>
                                        <td>
                                            <span v-html="item.dkzmj"></span>
                                        </td>
                                        <td>
                                            <span v-html="item.cjje"></span>
                                        </td>
                                        <td>
                                            <a @click="detailsOpen(item.code)" href="javascript:void(0);">查看详情</a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div>
                        <div class="header">
                            各行政区成交金额统计
                        </div>
                        <div class="content">
                            <div id="amountStatistical" style="width: 100%;height: 100%;"></div>
                        </div>
                    </div>
                    <div>
                        <div class="header">
                            各行政区地块数量统计
                        </div>
                        <div class="content">
                            <div id="regionNumStatistical" style="width: 100%;height: 100%;"></div>
                        </div>
                    </div>
                    <div>
                        <div class="header">
                            各行政区地块面积统计
                        </div>
                        <div class="content">
                            <div id="regionAreaStatistical" style="width: 100%;height: 100%;"></div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
        </div>
        <v-details ref="details"></v-details>
    </div>
</template>

<script>
import { mapResourceApi } from '@/api/mapResourceApi'
import { xzqUtils } from '@/views/class/mapmanager'
import vDetails from '@/views/managementSystem/analysis/details'
import { landinifoApi } from '@/api/managementSystemApi'
import { Notification } from 'element-ui'
const echarts = require('echarts')
export default {
  components: {
    vDetails
  },
  data() {
    return {
      searchParams: [],
      xzqList: xzqUtils.xzqArray,
      xzq: '0',
      time: 'all',
      customTime: '',
      cjzt: '',
      queryData: [],
      cjztList: [{
        label: '全部',
        value: ''
      }, {
        label: '已出让',
        value: '1'
      }, {
        label: '未出让',
        value: '0'
      }],
      tdyt: '',
      tdytList: [{
        label: '全部',
        value: ''
      }, {
        label: '住宅用地',
        value: '1'
      }, {
        label: '商服用地',
        value: '2'
      }, {
        label: '工业用地',
        value: '3'
      }, {
        label: '其他',
        value: '4'
      }],
      tableList: [],
      ghztList: [{
        label: '全部',
        value: ''
      }, {
        label: '已过会',
        value: '0'
      }, {
        label: '未过会',
        value: '1'
      }],
      ghzt: '',
      moreSearchShow: false
    }
  },
  watch: {
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {
    this.initXzqUtils()
    this.getData()
  },
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.$nextTick(() => {
      this.amountStatisticalCharts()
      this.regionNumStatisticalCharts()
      this.regionAreaStatisticalCharts()
    })
  },
  methods: {
    initXzqUtils() {
      const param = {}
      let cantoncity = '株洲市'
      for (let i = 0; i < city.length; i++) {
        if (city[i].check === true) {
          cantoncity = city[i].cityname
        }
      }
      param.cantoncity = cantoncity
      mapResourceApi.selectByCityName(param).then(res => {
        if (res.code === '200') {
          if (res.data.length > 0) {
            localStorage.setItem('xzqUtil_datas', JSON.stringify(res.data))
            const txzqNameArray = []
            const txzqEidtArray = []
            const txzqArray = [{
              label: '全部',
              value: '0'
            }]
            for (let i = 0; i < res.data.length; i++) {
              const datas = new Object()
              datas.label = res.data[i].cantonname
              datas.value = res.data[i].cantoncode
              txzqNameArray.push(res.data[i].cantonname)
              txzqEidtArray.push(datas)
              txzqArray.push(datas)
            }
            xzqUtils.xzqNameArray = txzqNameArray
            xzqUtils.xzqEidtArray = txzqEidtArray
            xzqUtils.xzqArray = txzqArray
            this.xzqList = txzqArray
            localStorage.setItem('xzqList', JSON.stringify(txzqArray))
            localStorage.setItem('xzqEidtArray', JSON.stringify(txzqEidtArray))
            localStorage.setItem('xzqNameArray', JSON.stringify(txzqNameArray))
          }
        }
      })
    },
    moreButton() {
      this.moreSearchShow = !this.moreSearchShow
    },
    getData() {
      let xzq = ''
      let crzt = ''
      let ydxz = ''
      let kssj = ''
      let jssj = ''
      let ghzt = ''
      let sqdw = ''
      const registerType = localStorage.registerType
      if (registerType === '0') {
        sqdw = localStorage.sqdw
      }
      xzq = this.xzq
      crzt = this.cjzt
      ydxz = this.tdyt
      ghzt = this.ghzt
      if (this.time === 'all') {
        kssj = ''
        jssj = ''
      } else if (this.time === 'year') {
        const nowYear = new Date().getFullYear()
        kssj = new Date(nowYear, 0, 1)
        kssj = this.formatDate(kssj)
        kssj = kssj + ' 00:00:00'
        jssj = new Date(nowYear, 11, 31)
        jssj = this.formatDate(jssj)
        jssj = jssj + ' 23:59:59'
      } else if (this.time === 'quarter') {
        kssj = this.getQuarterStartDate()
        kssj = kssj + ' 00:00:00'
        jssj = this.getQuarterEndDate()
        jssj = jssj + ' 23:59:59'
      } else if (this.time === 'month') {
        kssj = this.getMonthStartDate()
        kssj = kssj + ' 00:00:00'
        jssj = this.getMonthEndDate()
        jssj = jssj + ' 23:59:59'
      } else if (this.time === 'custom') {
        const custom = this.customTime
        if (custom !== '') {
          kssj = custom[0]
          jssj = custom[1]
          kssj = this.formatDate(kssj)
          kssj = kssj + ' 00:00:00'
          jssj = this.formatDate(jssj)
          jssj = jssj + ' 23:59:59'
        } else {
          Notification.warning({
            title: '警告',
            message: '请选择时间段再进行统计分析!',
            type: 'warning'
          })
          return
        }
      }
      if (xzq === '0') {
        xzq = ''
      }
      const params = {
        xzq,
        crzt,
        ghzt,
        ydxz,
        sqdw,
        kssj,
        jssj
      }
      this.queryData = params
      landinifoApi.statisticsLandDk(params).then(response => {
        if (response.code === '200') {
          this.tableList = []
          const data = response.data
          if (data.length !== 0) {
            data.forEach(element => {
              element.code = element.xzq
              element.xzq = xzqUtils.getXZQNAME(element.xzq)
              element.dkzmj = parseFloat(element.dkzmj).toFixed(3)
            })
            for (let k = 0; k < data.length; k++) {
              if (data[k].xzq !== '') { this.tableList.push(data[k]) }
            }
            const xzqNames = xzqUtils.xzqNameArray
            let txzq = this.xzq
            if (txzq === '0') {
              txzq = ''
            }
            if (txzq === '') {
              if (xzqNames.length > data.length) {
                for (let i = 0; i < xzqNames.length; i++) {
                  const xzq = xzqNames[i]
                  const code = xzqUtils.getXZQCODE(xzq)
                  let flag = false
                  for (let j = 0; j < data.length; j++) {
                    if (xzq === data[j].xzq) {
                      flag = true
                      break
                    } else {
                      flag = false
                    }
                  }
                  if (flag === false) {
                    const sjlist = {
                      xzq,
                      code,
                      dksl: '0',
                      dkzmj: '0.000',
                      cjje: '0'
                    }
                    this.tableList.push(sjlist)
                  }
                }
              }
            }
          } else {
            let txzq = this.xzq
            if (txzq === '0') {
              txzq = ''
            }
            if (txzq === '') {
              const xzqNames = xzqUtils.xzqNameArray
              for (let i = 0; i < xzqNames.length; i++) {
                const xzq = xzqNames[i]
                const code = xzqUtils.getXZQCODE(xzq)
                const sjlist = {
                  xzq,
                  code,
                  dksl: '0',
                  dkzmj: '0.000',
                  cjje: '0'
                }
                this.tableList.push(sjlist)
              }
            } else {
              const code = txzq
              const xzq = xzqUtils.getXZQNAME(txzq)
              this.tableList = [{
                xzq,
                code,
                dksl: '0',
                dkzmj: '0.000',
                cjje: '0'
              }]
            }
          }

          this.amountStatisticalCharts()
          this.regionNumStatisticalCharts()
          this.regionAreaStatisticalCharts()
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
        }
      })
    },
    statisticsData() {
      this.getData()
    },
    resetForm() {
      // 重置
      this.xzq = '0'
      this.cjzt = ''
      this.tdyt = ''
      this.ghzt = ''
      this.time = 'all'
      this.customTime = ''
    },
    exportDk() {
      const queryxx = this.queryData
      const tjsjList = queryxx.kssj + ',' + queryxx.jssj
      let param = {}
      if (queryxx.kssj === '' && queryxx.jssj === '') {
        param = {
          pageNo: 0,
          pageSize: 0,
          params: [
            {
              column: 'xzq',
              type: 'EQ',
              val: queryxx.xzq
            },
            {
              column: 'ydxz',
              type: 'EQ',
              val: queryxx.ydxz
            },
            {
              column: 'crzt',
              type: 'EQ',
              val: queryxx.crzt
            },
            {
              column: 'ghzt',
              type: 'LIKE',
              val: queryxx.ghzt
            },
            {
              column: 'sqdw',
              type: 'EQ',
              val: queryxx.sqdw
            }
          ]
        }
      } else {
        param = {
          pageNo: 0,
          pageSize: 0,
          params: [
            {
              column: 'xzq',
              type: 'EQ',
              val: queryxx.xzq
            },
            {
              column: 'ydxz',
              type: 'EQ',
              val: queryxx.ydxz
            },
            {
              column: 'crzt',
              type: 'EQ',
              val: queryxx.crzt
            },
            {
              column: 'ghzt',
              type: 'LIKE',
              val: queryxx.ghzt
            },
            {
              column: 'commit_date',
              type: 'BETWEEN',
              val: tjsjList
            },
            {
              column: 'sqdw',
              type: 'EQ',
              val: queryxx.sqdw
            }
          ]
        }
      }
      landinifoApi.selectByPage(param).then(response => {
        if (response.code === '200') {
          const list = response.data.list
          if (list && list.length > 0) {
            let acData = new Array()
            for (let i = 0; i < list.length; i++) {
              const dkxxList = new Array()
              if (list[i].xzq) {
                dkxxList[0] = xzqUtils.getXZQNAME(list[i].xzq)
              } else {
                dkxxList[0] = ''
              }
              if (list[i].sqdw) {
                dkxxList[1] = list[i].sqdw
              } else {
                dkxxList[1] = ''
              }
              if (list[i].dkdz) {
                dkxxList[2] = list[i].dkdz
              } else {
                dkxxList[2] = ''
              }
              if (list[i].tdyt) {
                dkxxList[3] = list[i].tdyt
              } else {
                dkxxList[3] = ''
              }
              if (list[i].dkmj) {
                dkxxList[4] = parseFloat(list[i].dkmj).toFixed(3)
              } else {
                dkxxList[4] = ''
              }
              if (list[i].cjj) {
                dkxxList[5] = list[i].cjj + ''
              } else {
                dkxxList[5] = ''
              }
              if (list[i].crzt === '1') {
                dkxxList[6] = '已出让'
              } else {
                dkxxList[6] = '未出让'
              }
              if (list[i].ghzt === '0') {
                dkxxList[7] = '已过会'
              } else {
                dkxxList[7] = '未过会'
              }
              if (list[i].tjDate) {
                dkxxList[8] = list[i].tjDate
              } else {
                dkxxList[8] = ''
              }
              acData.push(dkxxList)
            }
            if (acData && acData.length > 0) {
              const type = 1
              acData = JSON.stringify(acData)
              const acParams = {
                acData,
                type
              }
              landinifoApi.excelMainDisposeDk(acParams).then(response => {
                const tmpFileName = response// .responseText;
                const versionStr = tmpFileName.split('@')
                const tempUrl = encodeURIComponent(versionStr[1])
                const tempName = encodeURIComponent(versionStr[0])
                let url = `${gisserverUrl}` + '/openApi/ExcelMainDispose/TodoExcelDownload'
                url += '?diskPath=' + tempUrl
                url += '&fileName=' + tempName
                window.location.href = url
              })
            }
          } else {
            Notification.warning({
              title: '警告',
              message: '地块详细信息为空,无法导出！',
              type: 'warning'
            })
          }
        } else {
          Notification.warning({
            title: '警告',
            message: '获取数据出错!',
            type: 'warning'
          })
        }
      })
    },
    // 获得本季度的开端月份
    getQuarterStartMonth() {
      const nowMonth = new Date().getMonth() // 当前月
      let quarterStartMonth = 0
      if (nowMonth < 3) {
        quarterStartMonth = 0
      }
      if (nowMonth > 2 && nowMonth < 6) {
        quarterStartMonth = 3
      }
      if (nowMonth > 5 && nowMonth < 9) {
        quarterStartMonth = 6
      }
      if (nowMonth > 8) {
        quarterStartMonth = 9
      }
      return quarterStartMonth
    },
    // 获得某月的天数
    getMonthDays(myMonth) {
      const nowYear = new Date().getFullYear()
      const monthStartDate = new Date(nowYear, myMonth, 1)
      const monthEndDate = new Date(nowYear, myMonth + 1, 1)
      const days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
      return days
    },
    // 获得本月的开端日期
    getMonthStartDate() {
      const nowYear = new Date().getFullYear()
      const nowMonth = new Date().getMonth()
      const monthStartDate = new Date(nowYear, nowMonth, 1)
      return this.formatDate(monthStartDate)
    },

    // 获得本月的停止日期
    getMonthEndDate() {
      const nowYear = new Date().getFullYear()
      const nowMonth = new Date().getMonth()
      const monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays(nowMonth))
      return this.formatDate(monthEndDate)
    },
    // 获得本季度的开端日期
    getQuarterStartDate() {
      const nowYear = new Date().getFullYear()
      const quarterStartDate = new Date(nowYear, this.getQuarterStartMonth(), 1)
      return this.formatDate(quarterStartDate)
    },

    // 获得本季度的停止日期
    getQuarterEndDate() {
      const nowYear = new Date().getFullYear()
      const quarterEndMonth = this.getQuarterStartMonth() + 2
      const quarterStartDate = new Date(nowYear, quarterEndMonth, this.getMonthDays(quarterEndMonth))
      return this.formatDate(quarterStartDate)
    },
    // 格局化日期：yyyy-MM-dd
    formatDate(date) {
      const myyear = date.getFullYear()
      let mymonth = date.getMonth() + 1
      let myweekday = date.getDate()

      if (mymonth < 10) {
        mymonth = '0' + mymonth
      }
      if (myweekday < 10) {
        myweekday = '0' + myweekday
      }
      return myyear + '-' + mymonth + '-' + myweekday
    },
    detailsOpen(xzqcode) {
      const code = xzqcode
      this.$refs.details.open(code, this.queryData)
    },
    amountStatisticalCharts() {
      const myChart = echarts.init(document.getElementById('amountStatistical'))
      const option = {
        color: ['#247fff', '#32c5e9', '#F5DE72', '#ff9f7f', '#fb6e90', '#8378ea'],
        title: [{
          y: '1%',
          left: '5%',
          text: '单位：万元',
          textStyle: {// 主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 'normal',
            color: '#666666'
          }
        },
        {
          y: '1%',
          right: '5%',
          text: '{a|总金额：}{b|}{c| 万元}',
          textStyle: {// 主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 'normal',
            rich: {
              a: {
                color: '#333333',
                fontSize: 14
              },
              b: {
                color: '#2789EE',
                fontSize: 18,
                fontWeight: 'bold'
              },
              c: {
                color: '#2789EE',
                fontSize: 14
              }
            }
          }
        }],
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255,255,255,0.8)', // 通过设置rgba调节背景颜色与透明度
          textStyle: {
            color: 'black'
          },
          formatter: '{b}：{c}，{d}%',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
          x: 'center',
          y: 'center'
        },
        legend: {
          x: 'center',
          bottom: '3%',
          textStyle: {
            color: '#333',
            fontSize: 14
          },
          icon: 'rect',
          itemWidth: 10, // 设置宽度
          itemHeight: 10, // 设置高度
          data: []
        },
        series: [
          // 主要展示层的
          {
            radius: ['30%', '55%'],
            center: ['center', 'center'],
            hoverAnimation: false,
            type: 'pie',
            label: {
              normal: {
                show: true,
                formatter: '{b}：{c}，{d}%',
                textStyle: {
                  fontSize: 14
                },
                position: 'outside'
              },
              emphasis: {
                show: true
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 20,
                length2: 30
              },
              emphasis: {
                show: true
              }
            },
            data: []
          }, {
            radius: ['30%', '40%'],
            center: ['center', 'center'],
            type: 'pie',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            data: [{
              value: 1,
              itemStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            }]
          }, {
            type: 'gauge',
            center: ['center', 'center'],
            radius: '74%',
            splitNumber: 100, // 刻度数量
            startAngle: '0',
            endAngle: '359.9',
            clockwise: false,
            axisLine: {
              show: true,
              lineStyle: {
                width: 8,
                shadowBlur: 0,
                color: [
                  [1, 'rgba(255,255,255,0.3)']
                ]
              }
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: true,
              length: 8,
              lineStyle: {
                color: '#D5D5D5',
                width: 2
              }
            },
            axisLabel: {
              show: false
            },
            pointer: { // 仪表盘指针
              show: 0
            },
            detail: {
              show: false
            }
          }
        ]
      }
      if (option && typeof option === 'object') {
        const list = this.tableList
        if (list && list.length > 0) {
          if (option.series && option.series[0]) {
            option.series[0].data = []
            for (let i = 0; i < list.length; i++) {
              const dkList = {}
              if (list[i].xzq) {
                dkList.name = list[i].xzq
              }
              if (list[i].cjje) {
                dkList.value = list[i].cjje
              }
              option.series[0].data.push(dkList)
            }
          }
          if (option.legend) {
            option.legend.data = []
            for (let j = 0; j < list.length; j++) {
              let xzqList = null
              if (list[j].xzq) {
                xzqList = list[j].xzq
              }
              option.legend.data.push(xzqList)
            }
          }
          if (option.title[1]) {
            option.title[1].text = ''
            let dkcjjsum = 0
            for (let k = 0; k < list.length; k++) {
              if (list[k].cjje) {
                const cjje = parseFloat(list[k].cjje)
                dkcjjsum += cjje
              }
            }
            option.title[1].text = '{a|总金额：}{b|' + dkcjjsum + '}{c| 万元}'
          }
        }
        myChart.setOption(option, true)
      }
      window.onresize = function () {
        myChart.resize()
      }
    },
    regionNumStatisticalCharts() {
      const myChart = echarts.init(document.getElementById('regionNumStatistical'))
      const colorArr = ['#247fff', '#32c5e9', '#F5DE72', '#ff9f7f', '#fb6e90', '#8378ea']
      const option = {
        title: {
          y: '1%',
          right: '5%',
          text: '{a|总数：}{b|}{c| 个}',
          textStyle: {// 主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 'normal',
            rich: {
              a: {
                color: '#333333',
                fontSize: 14
              },
              b: {
                color: '#2789EE',
                fontSize: 18,
                fontWeight: 'bold'
              },
              c: {
                color: '#2789EE',
                fontSize: 14
              }
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              opacity: 1
            }
          }
        },
        grid: {
          left: '5%',
          right: '3%',
          bottom: '2%',
          top: '20%',
          containLabel: true,
          z: 22
        },
        xAxis: [{
          type: 'category',
          gridIndex: 0,
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#E9EDED'
            }
          },
          axisLabel: {
            interval: 0,
            color: '#333333',
            textStyle: {
              fontSize: 14
            }
          }
        }],
        yAxis: {
          type: 'value',
          name: '单位：个',
          nameTextStyle: {
            color: '#666666',
            fontSize: 14
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#E9EDED'
            }
          },
          gridIndex: 0,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#E9EDED'
            }
          },
          axisLabel: {
            formatter: '{value}',
            color: '#999999',
            textStyle: {
              fontSize: 14
            }
          }
        },
        series: [{
          type: 'bar',
          barWidth: 20,
          itemStyle: {
            normal: {
              show: true,
              color(params) {
                return colorArr[params.dataIndex]
              }
            }
          },
          data: []
        }]
      }
      if (option && typeof option === 'object') {
        const list = this.tableList
        if (list && list.length > 0) {
          if (option.xAxis && option.xAxis[0]) {
            option.xAxis[0].data = []
            for (let i = 0; i < list.length; i++) {
              let xzqmcList = null
              if (list[i].xzq) {
                xzqmcList = list[i].xzq
              }
              option.xAxis[0].data.push(xzqmcList)
            }
          }
          if (option.series && option.series[0]) {
            option.series[0].data = []
            for (let j = 0; j < list.length; j++) {
              let dkslList = null
              if (list[j].dksl) {
                dkslList = list[j].dksl
              }
              option.series[0].data.push(dkslList)
            }
          }
          if (option.title) {
            option.title.text = ''
            let dkslsum = 0
            for (let k = 0; k < list.length; k++) {
              if (list[k].dksl) {
                const dksl = parseFloat(list[k].dksl)
                dkslsum += dksl
              }
            }
            option.title.text = '{a|总数：}{b|' + dkslsum + '}{c| 个}'
          }
        }
        myChart.setOption(option, true)
      }
      window.onresize = function () {
        myChart.resize()
      }
    },
    regionAreaStatisticalCharts() {
      const myChart = echarts.init(document.getElementById('regionAreaStatistical'))
      const option = {
        title: {
          y: '1%',
          right: '5%',
          text: '{a|总面积：}{b|}{c| 亩}',
          textStyle: {// 主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: 'normal',
            rich: {
              a: {
                color: '#333333',
                fontSize: 14
              },
              b: {
                color: '#2789EE',
                fontSize: 18,
                fontWeight: 'bold'
              },
              c: {
                color: '#2789EE',
                fontSize: 14
              }
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              opacity: 1
            }
          }
        },
        grid: {
          left: '5%',
          right: '3%',
          bottom: '2%',
          top: '20%',
          containLabel: true,
          z: 22
        },
        xAxis: [{
          type: 'category',
          gridIndex: 0,
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#E9EDED'
            }
          },
          axisLabel: {
            interval: 0,
            color: '#333333',
            textStyle: {
              fontSize: 14
            }
          }
        }],
        yAxis: {
          type: 'value',
          name: '单位：亩',
          nameTextStyle: {
            color: '#666666',
            fontSize: 14
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#E9EDED'
            }
          },
          gridIndex: 0,
          splitLine: {
            show: true,
            lineStyle: {
              color: '#E9EDED'
            }
          },
          axisLabel: {
            formatter: '{value}',
            color: '#999999',
            textStyle: {
              fontSize: 14
            }
          }
        },
        series: [{
          type: 'line',
          symbolSize: 0,
          smooth: true,
          lineStyle: {
            normal: {
              width: 3,
              color: '#347AEE' // 线条颜色
            },
            borderColor: 'rgba(0,0,0,.4)'
          },
          itemStyle: {
            color: '#347AEE',
            borderColor: '#347AEE',
            borderWidth: 2
          },
          tooltip: {
            show: true
          },
          areaStyle: { // 区域填充样式
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(52,122,238,0.3)'}, {
                offset: 1,
                color: 'rgba(52,122,238,0)'
              }], false),
              shadowColor: 'rgba(52,122,238,0.1)', // 阴影颜色
              shadowBlur: 20
            }
          },
          data: []
        }]
      }
      if (option && typeof option === 'object') {
        const list = this.tableList
        if (list && list.length > 0) {
          if (option.xAxis && option.xAxis[0]) {
            option.xAxis[0].data = []
            for (let i = 0; i < list.length; i++) {
              let xzqmcList = null
              if (list[i].xzq) {
                xzqmcList = list[i].xzq
              }
              option.xAxis[0].data.push(xzqmcList)
            }
          }
          if (option.series && option.series[0]) {
            option.series[0].data = []
            for (let j = 0; j < list.length; j++) {
              let dkzmjList = null
              if (list[j].dkzmj) {
                dkzmjList = list[j].dkzmj
              }
              option.series[0].data.push(dkzmjList)
            }
          }
          if (option.title) {
            option.title.text = ''
            let dkzmjsum = 0
            for (let k = 0; k < list.length; k++) {
              if (list[k].dkzmj) {
                const dkzmj = parseFloat(list[k].dkzmj)
                dkzmjsum += dkzmj
              }
            }
            dkzmjsum = dkzmjsum.toFixed(3)
            option.title.text = '{a|总面积：}{b|' + dkzmjsum + '}{c| 亩}'
          }
        }
        myChart.setOption(option, true)
      }
      window.onresize = function () {
        myChart.resize()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
    @import "@/scss/list.scss";
    *{
        box-sizing: border-box;
    }
    .statistical-analysis{
        text-align: left;
        padding: 0 6px 10px 16px;
        height: 100%;
        width: 100%;
        .search{
            padding: 11px 0;
            table{
                width: 100%;
                border-collapse:collapse;
                border-spacing:0;
                td{
                    padding: 5px 0px;
                    .search-item{
                        .label{
                            width: 64px;
                            font-size: 14px;
                            text-align: right;
                            color: rgba(0,0,0,0.85);
                            margin-right: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            height: 32px;
                        }
                        .item{
                            width: calc(100% - 75px);
                            .el-select{
                                width: 95%;
                                max-width: 220px;
                            }
                            &.time-item{
                                line-height: 32px;
                                .custom-time{
                                    width: calc(100% - 330px);
                                    .el-date-editor{
                                        width: 220px;
                                        ::v-deep{
                                            .el-range-separator{
                                                width: 30px;
                                            }
                                        }
                                    }
                                }
                            }
                            ::v-deep{
                                .el-radio {
                                    color: #606266;
                                    font-weight: 500;
                                    cursor: pointer;
                                    margin-right: 10px;
                                    .el-radio__label {
                                        font-size: 14px;
                                        padding-left: 5px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        .analysis-content{
            height: calc(100% - 110px);
            .box-content{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                padding-right: 10px;
                >div{
                    width: calc((100% - 10px) / 2);
                    height: 430px;
                    background: #ffffff;
                    border: 1px solid #e8e8e8;
                    border-radius: 2px;
                    margin-bottom: 10px;
                    .header{
                        height: 48px;
                        background: #f5f5f5;
                        line-height: 48px;
                        padding-left: 10px;
                        font-size: 18px;
                        color: #333333;
                    }
                    .content{
                        height: calc(100% - 48px);
                        padding: 10px;
                        width: 100%;
                        table{
                            width: 100%;
                            border-collapse:collapse;
                            border-spacing:0;
                            th{
                                height: 48px;
                                background: #fafafa;
                                font-size: 16px;
                                text-align: center;
                                color: #515a6e;
                            }
                            td{
                                height: 48px;
                                font-size: 16px;
                                color: #333333;
                                text-align: center;
                                border-bottom: 1px solid #dddddd;
                                a{
                                    color: #2789ee;
                                }
                            }
                        }
                    }
                }
            }
            &.more-show{
                height: calc(100% - 152px);
            }
            ::v-deep{
                .el-scrollbar__wrap{
                    overflow-x: hidden;
                }
            }
        }
    }
</style>
